import type { ReactNode } from 'react';

import { Label } from '@/components/ui/label';

interface ChoiceOptionLabelProps {
  controlId: string;
  label: string;
  renderLabel?: (label: string) => ReactNode;
}

export function ChoiceOptionLabel({ controlId, label, renderLabel }: ChoiceOptionLabelProps) {
  if (!renderLabel) {
    return (
      <Label htmlFor={controlId} className="cursor-pointer font-normal">
        {label}
      </Label>
    );
  }

  return (
    <Label
      id={`${controlId}-label`}
      onClick={(event) => {
        if (!(event.target instanceof Element) || event.target.closest('a[href]')) return;
        const control = event.currentTarget.ownerDocument.getElementById(controlId);
        if (control?.contains(event.target)) return;
        control?.click();
      }}
      className="cursor-pointer font-normal"
    >
      {renderLabel(label)}
    </Label>
  );
}
